// O modelo AUTORAL do rébus — a fonte da verdade do editor.
//
// O rébus é o único tipo SEM GRADE: não há célula, coordenada nem blob. O documento
// é plano, imutável e serializável em JSON (contrato do shell: history, dirty
// tracking e o resto saem disso de graça).
//
// ⚠️ `numeracao` é o nome da COLUNA no banco, e o nome mente: o campo é texto livre
// exibido ao jogador como DICA — o portal renderiza `<span>{rebus.numeracao}</span>`
// (games/Rebus/index.tsx) e o app usa `styles.tip`. Por isso o rótulo na UI é
// "Dica"; ver Inspector.tsx. O nome do campo fica igual ao da coluna de propósito,
// para o `wire.ts` não ter que traduzir também isso.

import type { NewPuzzleParams } from '../../types';

export interface RebusDoc {
  /** Título do JOGO (mora em `jogos.titulo`, não na tabela `rebus`). */
  titulo: string;
  /** Dica textual mostrada ao jogador (coluna `numeracao` — ver o aviso acima). */
  numeracao: string;
  /** Resposta. Vai para o servidor em MAIÚSCULAS (o jogo compara assim) — a
   *  normalização mora no `wire.ts`. */
  solucao: string;
  /** URL pública da imagem, preenchida pelo upload. */
  imagem: string;
  /**
   * O jogo a que este rébus pertence, ou `null` enquanto ele ainda não existe no
   * servidor. Mora no doc porque DUAS decisões dependem dele e nenhuma tem acesso à
   * rota: o upload (`POST /admin/jogos/:id/rebus/imagem` exige um jogo já criado) e
   * o `validate` (cobrar imagem de um rébus que ainda não pode receber upload
   * fecharia o fluxo de criação num impasse — ver validate.ts).
   */
  idJogo: number | null;
}

/**
 * Documento vazio — o par de `load()` no fluxo de criação.
 *
 * `largura`/`altura` são IGNORADOS de propósito: rébus não tem grade, o módulo não
 * declara `dimensions` e o modal nem pergunta (chegam `0 × 0`, contrato de
 * `NewPuzzleParams`).
 */
export function createEmpty(params: NewPuzzleParams): RebusDoc {
  return {
    titulo: params.titulo,
    numeracao: '',
    solucao: '',
    imagem: '',
    idJogo: null,
  };
}
